<template>
  <div class="monitors">
    <div class="myVedioBox">
      <video
        class="video-js vjs-default-skin"
        ref="videoPlay1"
        loop
        autoplay
        :controls="false"
        playsinline
        style="object-fit: fill; width: 100%; height: 100%"
      >
        <source :src="src" type="application/x-mpegURL" />
      </video>
      <!-- 静音调整按钮 -->
      <button @click="toggleMute" class="mute-button">
        <i :class="isMuted ? 'fas fa-volume-mute' : 'fas fa-volume-up'"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';

const videoPlay1 = ref();
let Player1 = null;
const isMuted = ref(true); // 初始状态为静音

const VideoPlay = (src) => {
  nextTick(() => {
    Player1 = videojs(videoPlay1.value, {
      sources: [
        {
          src: src,
          type: "application/x-mpegURL",
        },
      ],
      muted: isMuted.value, // 初始化静音状态
    });
  });
};

const toggleMute = () => {
  isMuted.value = !isMuted.value;
  if (Player1) {
    Player1.muted(isMuted.value);
  }
};

// 接收父组件传递的 src
const props = defineProps({
  src: {
    type: String,
    required: true,
  },
});

onMounted(() => {
  VideoPlay(props.src);
});
onUnmounted(() => {
  if (Player1) {
    Player1.dispose();
  }
});
</script>

<style scoped lang='less'>
* {
  box-sizing: border-box;
}
.monitors {
  width: 100%;
  height: 100%;
  background: #ebf1f6;

  .myVedioBox {
    width: 100%;
    height: 100%;
    position: relative; // 使按钮定位在视频上
  }

  .mute-button {
    position: absolute;
    top: 1vw; // 保持顶部对齐
    right: 2vw; // 修改为右侧对齐
    padding: 0.5vw 0.5vw;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    border-radius: 0.5vw;
    cursor: pointer;
    z-index: 10; // 确保按钮在视频上方
  }
}
</style>